import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginConfirm } from 'app/model/user';

@Component({
  selector: 'app-login-confirm',
  templateUrl: './login-confirm.component.html',
  styleUrls: ['./login-confirm.component.scss']
})
export class LoginConfirmComponent implements OnInit {

  public loginConfirmForm: FormGroup

  @Output() onLoginConfirm: EventEmitter<LoginConfirm> = new EventEmitter<LoginConfirm>()

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.initializeValues()
  }

  private initializeValues(): void {
    this.createLoginConfirmForm()
  }

  private createLoginConfirmForm(): void {
    this.loginConfirmForm = new FormGroup({
      username: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required])
    })
  }

  private createLoginConfirm(): LoginConfirm {
    const values = this.loginConfirmForm.value

    const loginConfirm = new LoginConfirm()
    loginConfirm.username = values.username
    loginConfirm.password = values.password

    return loginConfirm
  }

  public onSubmit(): void {
    const userLoginConfirm = this.createLoginConfirm()

    this.onLoginConfirm.emit(userLoginConfirm)
  }
}
